<template>
    <article class="post" v-if="post">
        <div class="post_title">
            <h1>
                <span v-text="post.title.rendered"></span>
            </h1>
            <p v-text="publishedDate"></p>
        </div>
        <div class="post_main">
            <main class="content" v-html="post.content.rendered"></main>
            <ShareButtons :post="post" class="post_share" />
        </div>
        <div class="post_embed" v-if="post">
            <iframe allow="clipboard-write"
                sandbox="allow-top-navigation allow-top-navigation-by-user-activation allow-downloads allow-scripts allow-same-origin allow-popups allow-modals allow-popups-to-escape-sandbox allow-forms"
                allowfullscreen="true" style="border:none;left:0;right:0;top:0;bottom:0;" :src="magUrl"></iframe>
            <PostNavigation :post="post" class="post_navigation" mode="white" />
        </div>
        <!-- <HighlightsComponent class="post_highlights"/> -->
        <!-- <WidgetOne class="post_ods"/> -->
        <AdsComponent class="post_ad" />
    </article>
</template>

<script>
// @ is an alias to /src
// import WidgetOne from '@/components/WidgetOne.vue'
import AdsComponent from '@/components/Ads.vue'
// import HighlightsComponent from '@/components/Highlights.vue'
import PostNavigation from '@/components/PostNavigation.vue'
import ShareButtons from '@/components/ShareButtons.vue'
import moment from 'moment'

export default {
    name: 'BetanoMagPost',
    emits: ['ready'],
    components: {
        AdsComponent,
        // HighlightsComponent,
        PostNavigation,
        ShareButtons,
        // WidgetOne,
    },
    props: {
        slug: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
        }
    },
    methods: {
    },
    computed: {
        magUrl() {
            if (this.post) {
                return `https://e.issuu.com/embed.html?backgroundColor=%23transparent&backgroundColorFullscreen=%FF3C00&d=${this.post.acf.mag_id}&hideIssuuLogo=true&hideShareButton=true&u=betano.pt`
            }
            return null
        },
        post() {
            return this.$store.getters['betanomag/slug'](this.slug)
        },
        publishedDate() {
            if (this.post == null) {
                return null
            }
            let d = moment(this.post.date)
            return d.format("DD MMM YYYY")
        }
    },
    watch: {
        slug: {
            immediate: true,
            handler() {
                this.$store.dispatch("betanomag/getOne", { slug: this.slug })
            },
        },
        post: {
            immediate: true,
            handler() {
                if (this.post == null) {
                    return
                }
                this.$emit('ready')
            },
        },
    },
    mounted() {
    },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/colors';
@import '@/assets/scss/queries';
@import '@/assets/scss/fonts';

.post {
    --mag-embed-width: var(--content-width);
    --mag-embed-height: calc(var(--mag-embed-width) * 1.5);
    --mag-embed-iframe-width: 100%;
    //"ods"
    //"highlights"
    --mag-grid-areas:
        "title"
        "embed"
        "main"
        "ads"
    ;
    --mag-grid-columns: 100%;
    --mag-grid-rows: repeat(4, min-content);
    --mag-main-width: var(--content-width);
    --mag-padding: 120px 0 0;
    --mag-title-margin: calc(var(--content-width) * .08) auto;
    --mag-title-size: calc(var(--content-width) * .08);
    --mag-title-width: var(--content-width);
    --mag-widget-horizontal-width: 100%;

    --gap-size: calc((var(--content-width)) * .04);
    --content-padding: calc((100vw - var(--content-width)) / 2);

    @include media(sm) {
        --mag-embed-height: 100vh;
        --mag-embed-iframe-width: calc(var(--content-width) * .85);
        //"ods ods ods"
        //"highlights highlights highlights"
        --mag-grid-areas:
            ". title ."
            "embed embed embed"
            ". main ."
            "ads ads ads"
        ;
        --mag-grid-columns: var(--content-padding) 1fr var(--content-padding);
        --mag-grid-rows: min-content 1fr repeat(2, min-content);
        --mag-main-width: 100%;
        --mag-padding: var(--menu-height) 0;
        --mag-title-margin: 2rem 0 0;
        --mag-title-size: 4.22675rem;
        --mag-title-width: 100%;
        --mag-widget-horizontal-width: var(--content-width);
    }

    margin: auto;
    color: $color-white;
    display: grid;
    gap: calc(var(--gap-size) / 2) var(--gap-size);

    // padding: var(--menu-height) var(--mag-padding);
    padding: var(--mag-padding);
    grid-template-columns: var(--mag-grid-columns);
    grid-template-rows: var(--mag-grid-rows);
    grid-template-areas: var(--mag-grid-areas);

    &_ad {
        grid-area: ads;
        width: var(--content-width);
        margin: auto;
    }

    &_embed {
        grid-area: embed;
        position: relative;
        width: 100%;
        height: var(--mag-embed-height);
        max-height: 120vh;
        margin: 0 auto;
        margin-top: calc(var(--gap-size) * -1);
        background-color: $color-betano;
        padding: calc(var(--content-width) * .08) 0 calc(var(--content-width) * .04);
        display: flex;
        flex-direction: column;
        transform: skew(0deg, -5deg);
        box-shadow: 0 calc(var(--content-width)*.01) calc(var(--content-width)*.05) inset rgba(black, .7);
        z-index: 1;

        iframe,
        .post_navigation {
            transform: skew(0deg, 5deg);
        }

        iframe {
            width: var(--mag-embed-iframe-width);
            margin: 0 auto;
            flex-grow: 1;
        }
    }

    &_ods {
        grid-area: ods;
        width: var(--mag-widget-horizontal-width);
        margin: auto;
    }

    &_player {
        grid-area: player;
        width: 100%;

        @include media(sm, true) {
            display: none;
        }
    }

    &_title {
        grid-area: title;
        width: var(--mag-title-width);
        margin: var(--mag-title-margin);
        font-family: $ff-headings;

        h1 {
            line-height: 1;
            font-size: var(--mag-title-size);
            font-weight: 900;
            text-transform: uppercase;
        }

        p {
            font-size: 0.93925rem;
            text-transform: uppercase;
            font-family: $ff-headings;
            margin: 1rem 0;
        }
    }

    .header {
        max-width: var(--content-width);
        padding: 2rem 8rem;
        margin: auto;
        display: grid;
        grid-template-columns: 7fr 2fr;
        grid-template-areas:
            "title player"
        ;

        &_player {}
    }

    &_header {
        grid-area: header;
        position: relative;
    }

    &_highlights {
        grid-area: highlights;
        margin-top: var(--gap-size);
        --right-padding: (100vw - var(--content-width)) / 2;
        width: calc(100vw - var(--right-padding));
    }

    &_main {
        grid-area: main;
        color: $color-white;
        font-family: haffer;
        font-size: 0.90625rem;
        font-style: normal;
        font-weight: 400;
        line-height: 1.8125rem;
        /* 200% */
        margin: 0 auto;

        width: var(--mag-main-width);
        z-index: 2;

        :deep(h2) {
            color: $color-white;
            font-family: $ff-headings;
            font-size: 2.1625rem;
            font-weight: 800;
            line-height: 1;
            text-transform: uppercase;
            margin: 1em 0;
        }
    }

    &_related {
        grid-area: related;
    }

}
</style>
